import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ImageXplore from "../../Assets/Projects/ImageXplore.png";
import Movie from "../../Assets/Projects/Movie.png";
import Recipe from "../../Assets/Projects/Recipe.png"

import StoryTeller from "../../Assets/Projects/StoryTeller.png";
import Book from "../../Assets/Projects/Book.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>




          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Book}
              isBlog={false}
              title="Book App"
              description="A full-stack web application designed for book enthusiasts, built using the MERN stack. The app
                           enables users to explore a wide range of books, manage their personal collections, and view details
                            for each book. It features a user-friendly interface, dynamic routing, and a responsive design for seamless 
                            accessibility on various devices. With robust backend functionality, users can securely log in,
                             save preferences, and interact with the database for a personalized experience."

              ghLink="https://github.com/ritesh7397/Book-Store-FrontEnd"
              demoLink="https://book-store-1y89.onrender.com"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Movie}
              isBlog={false}
              title="Movie App"
              description="Movie-web is a cutting-edge movie application meticulously crafted with HTML, CSS, JavaScript, and React, offering users an unparalleled 
                          cinematic experience. Dive into a world of endless entertainment with our intuitive and feature-rich platform.
                          Real-time movie search functionality.
                          Dynamic lists of trending, top-rated, and upcoming movies.
                          Detailed movie pages with ratings, trailers, and descriptions.
                          Mobile-friendly responsive design."

              ghLink="https://github.com/ritesh7397/movie-web"
              demoLink="https://movie-web-40ut.onrender.com "
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Recipe}
              isBlog={false}
              title="Recipe App"
              description="A Recipe App created using React.js is a web application that allows users to discover, view,
                           and manage various recipes. Built with React.js, this app can efficiently handle the dynamic 
                           nature of recipe content, including adding, viewing, and filtering recipes based on ingredients,
                            cuisine, or dietary preferences.
                            Display a list of recipes based on search results
                            When a user clicks on a recipe, they can view detailed information like ingredients, 
                            instructions, preparation time, and nutritional facts."
              ghLink="https://github.com/ritesh7397/Recipe-App.git"
              demoLink="https://recipe-app-pog0.onrender.com"

            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={StoryTeller}
              isBlog={false}
              title="Story Teller App"
              description="The project is a mobile app that converts written text into sign language images for hearing-impaired children. It uses speech APIs
                           and natural language processing techniques to translate English words into Indian sign language"
              ghLink="https://github.com/ritesh7397/Story-Teller-App"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ImageXplore}
              isBlog={false}
              title="ImageXplore"
              description="ImageXplore is a visually captivating web application built with ReactJS that allows users to discover and explore stunning images from a
                           vast collection of photo databases. By leveraging an API for fetching high-quality images, the app delivers a seamless browsing experience,
                           showcasing various categories like nature, architecture, art, and more. The app’s clean and responsive design ensures that users can explore 
                           images effortlessly on any device."

              ghLink="https://github.com/ritesh7397/ImageXplore"
            />
          </Col>


        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
